import { ReactElement } from 'react';
import InvestorTable from './investorBased.table';
import GridItem from '../../../../layout/GridComponents/GridItem';
import { useSelector } from 'react-redux';
import { clientNameSelector } from '../../../../../redux/auth/selectors';
import { Typography } from '@mui/material';
import type { LiquidationRiskOverviewPayload } from '../component';

interface Props {
  overviewPayload: LiquidationRiskOverviewPayload;
  isFetching: boolean;
  section: string;
}

function InvestorBased({
  overviewPayload,
  isFetching,
  section,
}: Props): ReactElement {
  const clientName = useSelector(clientNameSelector) || 'mersenne';
  const testNameFirstScenario = clientName === 'gemini' ? '5x4%' : '3%';
  const testNameSecondScenario = clientName === 'gemini' ? '1x20%' : '10%';
  const firstScenarioValue = clientName === 'gemini' ? 4 : 3;
  const secondScenarioValue = clientName === 'gemini' ? 20 : 10;
  return (
    <>
      <GridItem xs={12} style={{ margin: '1.25rem 0 0 0', paddingBottom: 0 }}>
        <Typography
          variant="h1"
          style={{ paddingLeft: '0.62rem', fontSize: '1.50rem' }}
        >
          Investor Based Liquidity Reverse Stress Test
        </Typography>
      </GridItem>
      <InvestorTable
        section={section}
        loading={isFetching}
        overviewPayload={overviewPayload}
        inputKey="biz3"
        title={`Fund Status Under ${testNameFirstScenario} Redemptions - Business as usual`}
        redemptionLevel={firstScenarioValue}
      />
      <InvestorTable
        section={section}
        loading={isFetching}
        overviewPayload={overviewPayload}
        inputKey="biz10"
        title={`Fund Status Under ${testNameSecondScenario} Redemptions - Business as usual`}
        redemptionLevel={secondScenarioValue}
      />
      <InvestorTable
        section={section}
        loading={isFetching}
        overviewPayload={overviewPayload}
        inputKey="stress3"
        title={`Fund Status Under ${testNameFirstScenario} Redemptions - Super stressed`}
        redemptionLevel={firstScenarioValue}
      />
      <InvestorTable
        section={section}
        loading={isFetching}
        overviewPayload={overviewPayload}
        inputKey="stress10"
        title={`Fund Status Under ${testNameSecondScenario} Redemptions - Super stressed`}
        redemptionLevel={secondScenarioValue}
      />
      {clientName === 'gem' ? (
        <>
          <InvestorTable
            section={section}
            loading={isFetching}
            overviewPayload={overviewPayload}
            inputKey="sov3"
            title="Fund Status Under 3% Redemptions - EU Sovern Debt Crisis"
            redemptionLevel={firstScenarioValue}
            pdfDontMoveToNewPage={false}
          />
          <InvestorTable
            section={section}
            loading={isFetching}
            overviewPayload={overviewPayload}
            inputKey="sov10"
            title="Fund Status Under 10% Redemptions - EU Sovern Debt Crisis"
            redemptionLevel={secondScenarioValue}
          />
        </>
      ) : null}
    </>
  );
}

export default InvestorBased;
